<template>
  <div>
    <el-tag type="danger"
            size="medium"><span class="el-icon-time"> {{time|formatTimer}}</span></el-tag>
  </div>
</template>

<script>
export default {
  components: {},
  mixins: [],
  props: {
    value: Number,
    run: Boolean,
  },
  data () {
    return {
      time: 0,
      interval: null,
    }
  },
  computed: {},
  watch: {},
  beforeCreate () {},
  created () {
    this.startTimer()
  },
  mounted () {},
  destroyed () {
    this.stopTimer()
  },
  methods: {
    startTimer () {
      this.interval = setInterval(() => {
        this.time++
        this.$emit('input', this.time)
      }, 1000)
    },
    stopTimer () {
      clearInterval(this.interval)
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/order-review/components/OrderReviewTimer.vue